<template>
  <div>
    <header-applis titre="Adapter l’offre à votre expérience" index-progression-courante="2"/>
    <div class="wrapper__content">
      <ul>
        <li>
          <p>Au regard de vos réponses, il semble que le diplôme que vous visez ne vous est pas accessible.</p>
          <ul>
            <li>
              <p>Sans doute est-il nécessaire de repenser votre projet et/ou les précédentes informations renseignées ?</p>
            </li>
            <li>
              <p>Une fois cette orientation ajustée, nous vous invitons à reprendre la démarche engagée. Nous pourrons alors plus aisément donner suite à votre demande.</p>
            </li>
          </ul>
        </li>
        <button @click="rechercheProjet" class="button-app  big-button">
          Je consulte à nouveau l’offre et je reprends ma démarche
        </button>
        <button @click="connaitreInterlocuteur" class="button-app  big-button">
          J’ai besoin de connaître l’interlocuteur qui peut m’accompagner sur mon projet
        </button>
      </ul>
      <envoyer-recapitulatif/>
    </div>
    <footer-applis ecran-precedent="qualificationexperiencediplome"/>
  </div>
</template>

<script>
import EnvoyerRecapitulatif from '../components/EnvoyerRecapitulatif';
import FooterApplis from '../components/FooterApplis';
import HeaderApplis from '../components/HeaderApplis';

export default {
  name: 'diplomenonaccessible',
  components: {
    HeaderApplis,
    FooterApplis,
    EnvoyerRecapitulatif
  },
  methods: {
    rechercheProjet() {
      window.open('//fc.univ-nantes.fr/', '_blank')
      this.$router.push('/choixprojet');
    },
    connaitreInterlocuteur() {
      this.$router.push('/choixstatut');
    }
  }
}
</script>

<style scoped>
ul {
  list-style: none;
}
</style>
